import allPromisesWithRetries from '@/helpers/allPromisesWithRetries'
import {
  CSC_IAM_GUEST_IDP,
  CSC_IAM_ACCOUNT,
  GUEST_TOKEN_NAME,
} from '@/services/Configuration'

export const getGuestTokenFromLocalStorage = async () => {
  let jwt: null | string = null
  const tokenOnStorage = localStorage.getItem(GUEST_TOKEN_NAME)
  if (tokenOnStorage) {
  // If the token exists, assume you're good. If not, the implementer can clear the token and retry.
    jwt = tokenOnStorage
  } else {
    const [{ IAM }] = await allPromisesWithRetries(() => [import('@csc/csc-sdk')])
    const { token } = await IAM().getAnonymousJwtIdpToken({
      accountId: CSC_IAM_ACCOUNT, jwtIdpName: CSC_IAM_GUEST_IDP,
    })
    jwt = token
  }

  localStorage.setItem(GUEST_TOKEN_NAME, jwt)
  return jwt
}

export default getGuestTokenFromLocalStorage
